let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fUfhy")).then(() => parcelRequire('8lbWa'));